import React from 'react';
import {withRouter} from 'react-router-dom';
import {CardContainer, Player} from 'components/common/uiKit'
import {apiUrl} from 'services/network';


class VideoPlayer extends React.Component {
    constructor(props) {
        super(props);

        const path = props.location?.state?.path;
        if (!path)
            props.history.goBack();


        this.state = {
            url: `${apiUrl}/Media/Get?address=${path}`,
            index: props.location.state.index,
            total: props.location.state.total,
        }
    }


    render() {
        return (
            <CardContainer>
                <h4 className='color-primary font-weight-bold pb-3'>
                    {`فیلم شماره ${this.state.index} از ${this.state.total}`}
                </h4>
                <Player url={this.state.url}/>
            </CardContainer>
        );
    }
};

export default withRouter(VideoPlayer);